import type {GraphQLTaggedNode, OperationType, PreloadableConcreteRequest, Variables} from 'relay-runtime'

export const DEFAULT_RELAY_CACHE_TTL = 2 * 7 * 24 * 60 * 60 * 1000 // 2 weeks in milliseconds

/**
 * Creates a stable key from variables by sorting keys alphabetically.
 * Merges in default values for any missing variable keys.
 */
export function createVariablesKey(variables: Variables, defaults: Record<string, unknown> | undefined): string {
  const merged = mergeVariablesWithDefaults(variables, defaults)
  return JSON.stringify(merged, Object.keys(merged).sort())
}

/**
 * Merges variables with default values from query metadata.
 * For any variable key present in defaultValues but not in variables, the default value is used.
 */
function mergeVariablesWithDefaults(
  variables: Variables,
  defaultValues: Record<string, unknown> | undefined,
): Variables {
  return {...defaultValues, ...variables}
}

export function getDefaultValues<TQuery extends OperationType>(
  query: GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>,
): Record<string, unknown> | undefined {
  const defaultValues: Record<string, unknown> = {}
  if ('operation' in query) {
    const argumentDefinitions = query.operation.argumentDefinitions
    for (const argDef of argumentDefinitions) {
      if (argDef.defaultValue !== undefined && argDef.defaultValue !== null) {
        defaultValues[argDef.name] = argDef.defaultValue
      }
    }
  }
  return Object.keys(defaultValues).length > 0 ? defaultValues : undefined
}
